import { Col, Divider, Row, Skeleton, Space } from 'antd';
import React from 'react';

const AssignedCourseSkeleton = () => {
  return (
    <div className="min-h-screen">
      <Skeleton.Button size={'large'} className="mt-2" block active />
      <Divider block />
      <Row gutter={24}>
        <Col span={4}>
          <Skeleton.Button className="mb-3" active size="large" block />
          <Skeleton.Button className="mb-3" active size="large" block />
          <Skeleton.Button className="mb-3" active size="large" block />
          <Skeleton.Button className="mb-3" active size="large" block />
        </Col>
        <Col span={8}>
          <Skeleton.Button className="mb-6" active size="large" block />
          <Skeleton.Button className="mb-6" active size="large" block />
          <Skeleton.Button className="mb-6" active size="large" block />
          <Skeleton.Button className="mb-6" active size="large" block />
        </Col>
        <Col span={12}>
          <Skeleton.Input className="mb-2" active block />
          <Space
            className="mb-6"
            size={'large'}
            style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'start' }}
            wrap
          >
            <Skeleton.Input active block />
            <Skeleton.Image active block />
          </Space>
          <Space
            className="mb-6"
            size={'large'}
            style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'start' }}
            wrap
          >
            <Skeleton.Input active block />
            <Skeleton.Image active block />
          </Space>
          <Space
            className="mb-6"
            size={'large'}
            style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'start' }}
            wrap
          >
            <Skeleton.Input active block />
            <Skeleton.Image active block />
          </Space>
        </Col>
      </Row>
    </div>
  );
};

export default AssignedCourseSkeleton;
